export const MIN_PASSWORD_LENGTH = 12;

export const passwordPolicyMessage =
  "Password must be at least 12 characters long.";

export const isPasswordStrongEnough = (password = "") =>
  String(password).trim().length >= MIN_PASSWORD_LENGTH;
